import React from 'react';
import fetch from 'cross-fetch';
import { Col, Form, Row } from 'react-bootstrap';

import Article from './Article';
import CalculatorQuestion from './CalculatorQuestion';


class CalculatorStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articlePage: 0,
      articles: [],
      refs: props.questions.map(() => React.createRef())
    };

    this.retrieveArticles = this.retrieveArticles.bind(this);
    this.setArticles = this.setArticles.bind(this);
  }

  componentDidMount() {
    this.state.refs[0].current.focus();
    this.retrieveArticles();
  }

  retrieveArticles() {
    try {
      fetch(`/api/episerver/v1.0/search/content/?filter=ContentType/any(t:t eq 'ResourcePage')&top=5&skip=${this.state.articlePage}`)
        .then(response => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then(result => this.setArticles(result));
    }
    catch (ex) {
      console.log(ex);
    }
  }

  setArticles(result) {
    this.setState({
      articles: result.results
    });
  }

  render() {
    const { articles } = this.state;
    const { questions } = this.props;
    const showArticles = Array.isArray(articles) && articles.length > 0;
    
    return (
      <div className="calculator-step">
        <Row>
          <Col xs={12} sm={6} smOffset={3}>
            <Form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
              {questions && questions.map((question, index) => {
                return (
                  <CalculatorQuestion
                      key={`${index}-${question.name}`}
                      ref={this.state.refs[index]}
                      id={question.name}
                      label={question.label}
                      type={question.type}
                      validationState={question.validationState}
                      help={question.validationMessage}
                      defaultValue={question.defaultValue}
                      changeHandler={(value) => this.props.handleChange(index, value)}
                  />
                );
              })}
            </Form>
          </Col>
        </Row>
        {showArticles && 
          <div className='related-articles'>
            <h2>Related Articles</h2>
            {articles.map((article, i) => <Article article={article} key={i}/>)}
          </div>
        }
      </div>
    );
  }
}

export default CalculatorStep;
